import * as queryString from 'query-string';

export const INSTRUCTION_HUB_ENV_KEYS = {
  ENABLED: 'INSTRUCTION_HUB_ENABLED',
  RESULTS_ENABLED: 'INSTRUCTION_HUB_RESULTS_ENABLED',
  MANAGE_URL: 'INSTRUCTION_HUB_MANAGE_URL'
};

function getWindowEnv() {
  if (typeof window === 'undefined') {
    return {};
  }

  const envKey = '_env_';
  return window[envKey] || {};
}

export function getWindowSearch() {
  if (typeof window === 'undefined' || !window.location) {
    return '';
  }

  return window.location.search;
}

export function parseEnvBoolean(value) {
  return value === true || value === 'true';
}

function getFlag(env, queryParams, key) {
  const queryValue = queryParams[key];

  if (queryValue === 'true' || queryValue === 'false') {
    return queryValue === 'true';
  }

  return parseEnvBoolean(env[key]);
}

/**
 * Single toggle for whether Instruction Hub is used in the app.
 * Values come from the .env files via window._env_ and can be overridden
 * with a matching query param, eg ?INSTRUCTION_HUB_ENABLED=true.
 */
export function getInstructionHubFlags(
  env = getWindowEnv(),
  search = getWindowSearch()
) {
  const queryParams = queryString.parse(search);
  const isInstructionHubEnabled = getFlag(
    env,
    queryParams,
    INSTRUCTION_HUB_ENV_KEYS.ENABLED
  );

  return {
    isInstructionHubEnabled,
    isInstructionHubResultsEnabled:
      isInstructionHubEnabled &&
      getFlag(env, queryParams, INSTRUCTION_HUB_ENV_KEYS.RESULTS_ENABLED),
    instructionHubManageUrl: env[INSTRUCTION_HUB_ENV_KEYS.MANAGE_URL]
  };
}



// WEBPACK FOOTER //
// ./helpers/instruction-hub/instruction-hub-flags.js